// Components==============
import indexActivity from 'actions/activity/index';
import indexDream from 'actions/dream/index';
import indexFavorite from 'actions/favorite/index';
import indexFeedback from 'actions/feedback/index';
import indexGroowtorial from 'actions/groowtorial/index';
import indexNotification from 'actions/notification/index';
import indexPeople from 'actions/people/index';
import indexPortfolio from 'actions/portfolio/index';
import indexProjectGroup from 'actions/project-group/index';
import indexProject from 'actions/project/index';
import indexReflection from 'actions/reflection/index';
import indexSkills from 'actions/skill/index';
import indexTheme from 'actions/theme/index';
import indexAssessment from 'actions/assessment/index';
import indexTrainingSubscription from 'actions/training/subscription/index';
import indexTraining from 'actions/training/training/index';
import axios from 'axios';
import Layout from 'components/Layout/Layout';
import Container from 'components/UI/Container/Container';
import Spinner from 'components/UI/Spinner/Spinner';
import { useMediaQ } from 'hooks/useMediaQ';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { createContext, useContext, useEffect } from 'react';
import { HeroContent } from 'typings';
import { GlobalHeroContentContext } from 'utilities/GlobalContext/GlobalHeroContent';
import BottomCards from './components/BottomCards/BottomCards';
import RecentWork from './components/BottomCards/RecentWork';
import HeroCard from './components/HeroCard/HeroCard';
import SideMenu from './components/SideMenu/SideMenu';
import './Home.module.scss';
// =========================

type HomeContextType = {
  loading: boolean;
};

export const HomeContext = createContext({} as HomeContextType);

export default function Home() {
  const { heroContent, setHeroContent } = useContext(GlobalHeroContentContext);

  const dispatch = useReduxAction();

  useEffect(() => {
    if (!heroContent)
      axios
        .get('/api/dashboard-hero')
        .then(({ data }: { data: HeroContent }) => {
          setHeroContent(data);
        });

    dispatch(indexGroowtorial());
    dispatch(indexFavorite());
    dispatch(indexTrainingSubscription({}));
    dispatch(indexTraining());
    dispatch(indexTheme());
    dispatch(indexSkills());
    dispatch(indexProject());
    dispatch(indexPeople());
    dispatch(indexDream());
    dispatch(indexProjectGroup());
    dispatch(indexPortfolio());
    dispatch(indexReflection());
    dispatch(indexFeedback());
    dispatch(indexNotification());
    dispatch(indexActivity());
    dispatch(indexAssessment());
  }, []);

  const loading = useRedux(
    (state) =>
      state.groowtorial?.loading ||
      state.favorite?.loading ||
      state.training?.loading ||
      state.trainingSubscription?.loading ||
      state.theme?.loading ||
      state.project?.loading ||
      state.portfolio?.loading ||
      state.feedback?.loading ||
      heroContent === undefined
  );

  const query = useMediaQ('min', 1024);

  return (
    <Layout grey>
      <HomeContext.Provider value={{ loading }}>
        <div styleName="wrapper">
          <div styleName="scroll-container">
            <Container>
              {heroContent === undefined ? (
                <Spinner loading={loading} fullPage />
              ) : (
                <div styleName="content-wrapper">
                  <HeroCard />
                  <RecentWork />
                  <BottomCards />
                </div>
              )}
            </Container>
          </div>
          {query && <SideMenu />}
        </div>
      </HomeContext.Provider>
    </Layout>
  );
}
